import type { ErrorEvent } from "@sentry/react";

import { getOpenReplaySessionUrl } from "./openreplay";

/**
 * Adds what a reader of a Sentry event needs and cannot search for today.
 *
 * - The GraphQL operation as a tag. The error reporters put it in `extra`,
 *   which Sentry shows but cannot search.
 * - The OpenReplay recording at the moment of the error, to see what the
 *   user did before it.
 */
export const addSentryEventContext = (event: ErrorEvent): ErrorEvent => {
  const operationName = event.extra?.operationName;
  if (typeof operationName === "string" && operationName) {
    event.tags = { ...event.tags, "graphql.operation": operationName };
  }

  const sessionUrl = getOpenReplaySessionUrl();
  if (sessionUrl) {
    event.contexts = { ...event.contexts, openreplay: { url: sessionUrl } };
  }

  return event;
};
